var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ProcessDocumentService = /** @class */ (function (_super) {
            __extends(ProcessDocumentService, _super);
            function ProcessDocumentService($http, $q) {
                var _this = _super.call(this, $http) || this;
                _this.$q = $q;
                return _this;
            }
            ProcessDocumentService.prototype.updateProcessDocuments = function (process, newDocuments, oldDocIds) {
                var defer = this.$q.defer();
                var newDocIds = Enumerable.from(newDocuments).select(function (i) { return i.id; }).toArray();
                if (process.documents && process.documents.length > 0) {
                    // Remove old and any updated documents from current list
                    process.documents = Enumerable.from(process.documents)
                        .where(function (i) { return (!oldDocIds || oldDocIds.indexOf(i.id) === -1) && (!newDocIds || newDocIds.indexOf(i.id) === -1); })
                        .toArray();
                }
                if (newDocuments && newDocuments.length > 0) {
                    process.documents = process.documents.concat(newDocuments);
                }
                this.updateManageDocumentSections(process).then(function () {
                    defer.resolve();
                });
                return defer.promise;
            };
            ProcessDocumentService.prototype.getDocumentById = function (process, id) {
                if (process && process.documents) {
                    var match = Enumerable.from(process.documents).singleOrDefault(function (i) { return i.id === id; });
                    if (match)
                        return match;
                }
                return undefined;
            };
            ProcessDocumentService.prototype.updateManageDocumentSections = function (process) {
                var defer = this.$q.defer();
                this.handlerUrl = "api/Process/" + process.id + "/DocumentManageSections";
                var params = {};
                this.useGetHandler(params).then(function (processDto) {
                    process.documentSections = processDto.documentSections;
                    defer.resolve();
                });
                return defer.promise;
            };
            return ProcessDocumentService;
        }(services.HttpHandlerService));
        services.ProcessDocumentService = ProcessDocumentService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("ProcessDocumentService", ["$http", "$q"]);
